interface KeywordBadgesProps {
  keywords: { es: string[]; en: string[] };
}

export default function KeywordBadges({ keywords }: KeywordBadgesProps) {
  return (
    <div className="space-y-3">
      <div>
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Español</p>
        <div className="flex flex-wrap gap-2">
          {keywords.es.map((kw) => (
            <span key={kw} className="keyword-badge">{kw}</span>
          ))}
        </div>
      </div>
      <div>
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">English</p>
        <div className="flex flex-wrap gap-2">
          {keywords.en.map((kw) => (
            <span key={kw} className="keyword-badge">{kw}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
